import { Injectable } from '@angular/core';
import { CustomHttp } from '../../shared/custom.http';

@Injectable()
export class ImageUpdateService {
    private imageUpdateURL = '/v2/images';

    constructor(private http: CustomHttp) {
    }

    postClaimImage(titleId: string, title: string, username: string) {
        const url = `${this.imageUpdateURL}/claim?titleId=${titleId}&title=${encodeURIComponent(title)}&username=${username}`;
        return this.http.post(url, { body: '' });
    }

    deleteClaimImage(titleId: string) {
        const url = `${this.imageUpdateURL}/claim?titleId=${titleId}`;
        return this.http.delete(url, { body: '' });
    }

    getImageUpdateRequest(titleId?: string, state?: string[]) {
        let url: string;
        if (titleId && state) {
            url = `${this.imageUpdateURL}/?titleId=${titleId}&state=${state.join('&state=')}`;
        } else if (titleId) {
            url = `${this.imageUpdateURL}/?titleId=${titleId}`;
        } else if (state) {
            url = `${this.imageUpdateURL}/?state=${state.join('&state=')}`;
        } else {
            return new Promise((resolve, reject) => {resolve({}); });
        }
        return this.http.get(url, { body: '' });
    }

    postImageUpdate(file: any, username: string, parrotId: string, title: string, imageType: string, genomeState: string, contentType: string) {
        // The way that the http service does post requests is not compatible with
        // multipart data.

        if(imageType == 'banner'){
            imageType = 'background';
        }

        if(contentType === 'talent' && !((imageType === 'banner') || (imageType === 'background'))){
            imageType = 'portrait';
        }

        const url = `${this.http.getBaseUrl()}${this.imageUpdateURL}/upload`;
        const authToken = localStorage.getItem('id_token');
        const formData = new FormData();
        formData.append('username', username);
        formData.append('imageType', imageType);
        formData.append('titleId', parrotId);
        formData.append('title', title);
        formData.append('genomeState', genomeState);
        formData.append('file', file);
        formData.append('content_type', contentType);

        return fetch(url, {
            method: 'POST',
            body: formData,
            headers: {
                'x-auth-token': authToken
            }
        });
    }

    putImageQa(titleId: string, idUpdatedUser: string, state: string, imageType: string, genomeState, contentType) {

        if(imageType == 'banner'){
            imageType = 'background';
        }


        if(contentType === 'talent' && !((imageType === 'banner') || (imageType === 'background'))){
            imageType = 'portrait';
        }



        const url = `${this.imageUpdateURL}/qa/?titleId=${
            titleId}&idUpdatedUser=${idUpdatedUser}&state=${state}&imageType=${
            imageType}&genomeState=${genomeState}&content_type=${contentType}`;
        return this.http.put(url, { body: '' });
    }

    postProdQA(titleId: string, title: string, username: string) {
        const url = `${this.imageUpdateURL}/prod_qa?titleId=${titleId}` +
            `&title=${title}&username=${username}`;

        return this.http.post(url, {});
    }

    getCount(startDate: Date, endDate: Date) {
        // Convert the dates to acceptable strings
        const startDateString = startDate.toISOString().slice(0, 10);
        const endDateString = endDate.toISOString().slice(0, 10);

        const url = `${this.imageUpdateURL}/count?startDate=${startDateString}&endDate=${endDateString}`;
        return this.http.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/image-update/image-update.service.ts